import React, { useState } from 'react';
import { Dialog } from '@mui/material';
import { CookieOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import GetCookie from '../Services/GetCookie';
import SetCookie from '../Services/SetCookie';

const CookieConsent = () => {
  const [open, setOpen] = useState(false);  // Le popup est fermé par défaut
  const [pageLoad, setPageLoad] = useState(true);


  if (pageLoad) {
    setPageLoad(false)
    try {
      if (GetCookie('cookiesAccepted') === undefined) {
        setOpen(true)
      }
    } catch (error) {
      setOpen(true)
    }

  }


  const handleClose = (val: boolean) => {
    SetCookie("cookiesAccepted", val)
    setOpen(false);
  };

  const { t } = useTranslation();

  return (
    <Dialog open={open} maxWidth="sm" PaperProps={{ className: 'ibg-cookie' }}>
      <div className='ibg-cookie__head'>
        <span className='ibg-cookie__icon'><CookieOutlined /></span>
        <h2>{t("Texte.cookiesTitre")}</h2>
      </div>
      <p>
        {t("Texte.cookiesContenu")}
      </p>
      {/* <FormControlLabel
          control={
            <Checkbox
              checked={accepted}
              onChange={handleCheckboxChange}
              name="acceptCookies"
            />
          }
          label="I accept the use of cookies."
        /> */}
      <div className='ibg-cookie__actions'>
        <button className='btn3' onClick={() => { handleClose(false) }}>
          {t("Texte.cookiesBtnRefuse")}
        </button>
        <button className='btn' onClick={() => { handleClose(true) }}>
          {t("Texte.cookiesBtnAccept")}
        </button>
      </div>
    </Dialog>
  );
};

export default CookieConsent;
